<template>
<div ui-view="" class="app-body" id="view">
  <component v-bind:is="component"></component>
</div>
</template>

<script>
//import UserDetail from './UserDetail.vue'
import VisitorList from './inOut/_BookList.vue'

export default {
  components: { VisitorList},
  data() {
    return {
      component: null
    }
  },
  mounted(){
    this.init();
  },
  watch:{
    $route(to) { 
      this.init();
    }
  },
  methods: {
    init(){
      

      /*
      if(this.$route.query.mode== 'view'){
        this.component = UserDetail
        return;
      }
      */
      if(this.$route.query.mode== 'new'){
        //this.component = UserEdit
        return;
      }
      
      if(typeof this.$route.query.mode == "undefined" || this.$route.query.mode == 'list' || this.$route.query.mode == ''){
        this.component = VisitorList
        return;
      }      
    }
  },
}
</script>

<style>

</style>